import script from "./header.vue?vue&type=script&setup=true&lang=ts"
export * from "./header.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__